import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from '@/App'
import { AuthProvider } from '@/hooks/useAuth'
import { bootAuth } from '@/lib/auth'
import './application.css'

bootAuth()

const queryClient = new QueryClient()

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('root')
  if (!el) return

  createRoot(el).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  )
})
